import PendoButton from '../../../components/button/pendo-button.vue.js';
import PendoTooltip from '../../../directives/tooltip/pendo-tooltip.js';

var script = {
  name: 'EditAction',
  components: {
    PendoButton
  },
  directives: {
    PendoTooltip
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    }
  },
  methods: {
    openModal() {
      this.$emit('modal-open', {
        action: 'edit',
        id: this.id,
        description: this.description
      });
    }
  }
};

export { script as default };
//# sourceMappingURL=edit-action.vue2.js.map
